import type { Pumps } from "gql/api";

export function computePumpLabel(
  pump: Partial<Pumps> | undefined | null,
  useHSShaft?: boolean | null | undefined
): string | null {
  if (pump) {
    return useHSShaft === true
      ? `${pump.manufacturer} / ${pump.series_model} (HS Shaft)`
      : `${pump.manufacturer} / ${pump.series_model} (STD Shaft)`;
  }
  return "";
}

export function computePumpStageType(
  pump: Partial<Pumps> | undefined | null
): string | null {
  switch (pump?.stage_type) {
    case 0:
      return "Radial";
    case 1:
      return "Mixed";
    case 2:
      return "Axial";
    default:
      return "";
  }
}
